import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Formik, Form as FormFormik } from "formik";
import VMasker from "vanilla-masker";

import { formatToUpdate } from "../../utils/price-format";
import { increment, decrement } from "../../utils/controls-input-number";

import {
  ModalContainer,
  ModalContent,
  CloseModal,
  IconCloseModal,
  Title,
  Form,
} from "./styles";
import { Button } from "../../atoms/Button";

import FieldCustom from "../../organisms/FieldCustom";
import InputNumber from "../../atoms/InputNumber";
import TextArea from "../../atoms/TextArea";

import validations from "./validations";

ModalProductUpdate.propTypes = {
  visible: PropTypes.bool.isRequired,
  handleToggleVisibility: PropTypes.func.isRequired,
  product: PropTypes.object.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
};

function ModalProductUpdate({
  visible,
  handleToggleVisibility,
  product,
  handleSubmit,
  isSubmitting,
}) {
  const [initialValues, setInitialValues] = useState({
    id: "",
    name: "",
    unit_price: "",
  });

  useEffect(() => {
    setInitialValues({
      id: product.id ? product.id : "",
      name: product.name ? product.name : "",
      unit_price: product.unit_price ? formatToUpdate(product.unit_price) : "",
    });
  }, [product]);

  return (
    <ModalContainer visible={visible}>
      <ModalContent>
        <CloseModal onClick={handleToggleVisibility}>
          <IconCloseModal />
        </CloseModal>
        <Title>Atualizar dados do produto</Title>
        <Formik
          enableReinitialize={true}
          initialValues={initialValues}
          validationSchema={validations}
          onSubmit={(values, { resetForm }) => {
            handleSubmit(values);
            resetForm({
              id: "",
              name: "",
              unit_price: "",
            });
          }}
        >
          {({
            dirty,
            isValid,
            touched,
            errors,
            handleChange,
            handleBlur,
            setFieldValue,
            values,
          }) => (
            <FormFormik as={Form}>
              <fieldset>
                <FieldCustom
                  as={TextArea}
                  name="name"
                  type="text"
                  title="Descrição"
                  placeholder="Descrição..."
                  touched={touched.name}
                  errors={errors.name}
                  value={values.name}
                  handleChange={(value) => handleChange(value)}
                  handleBlur={(value) => handleBlur(value)}
                  maxLength={150}
                />

                <FieldCustom
                  as={InputNumber}
                  name="unit_price"
                  type="text"
                  title="Valor unitário"
                  placeholder="Valor unitário (reais)"
                  touched={touched.unit_price}
                  errors={errors.unit_price}
                  value={values.unit_price}
                  handleChange={(e) => {
                    setFieldValue(
                      "unit_price",
                      VMasker.toMoney(e.target.value)
                    );
                  }}
                  handleBlur={(value) => handleBlur(value)}
                  increment={() =>
                    setFieldValue(
                      "unit_price",
                      VMasker.toMoney(increment(values.unit_price))
                    )
                  }
                  decrement={() =>
                    setFieldValue(
                      "unit_price",
                      VMasker.toMoney(decrement(values.unit_price))
                    )
                  }
                />

                {/*   <FieldCustom
                  as={InputNumber}
                  name="stock"
                  type="number"
                  title="Quantidade"
                  placeholder="Quantidade"
                  touched={touched.stock}
                  errors={errors.stock}
                  handleChange={(value) => handleChange(value)}
                  handleBlur={(value) => handleBlur(value)}
                  increment={() =>
                    setFieldValue("stock", Number(values.stock) + 1)
                  }
                  decrement={() =>
                    setFieldValue("stock", Number(values.stock) - 1)
                  }
                /> */}
              </fieldset>
              <Button
                disabled={!dirty || !isValid || isSubmitting}
                type="submit"
                mt="30"
                primary
                upper
                sm
                fullWidth
              >
                Atualizar
              </Button>
            </FormFormik>
          )}
        </Formik>
      </ModalContent>
    </ModalContainer>
  );
}

export default ModalProductUpdate;
